// extracted by mini-css-extract-plugin
module.exports = {"NavList":"NavList_NavList__2TSPt"};